import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/adminApi";
import { Input } from "@/components/ui/input";
import { ArrowRight, Lock, Loader2 } from "lucide-react";
import { BRAND } from "@/lib/config";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await adminLogin(password);
      navigate("/admin/leads", { replace: true });
    } catch (err) {
      setError(
        err?.response?.status === 401
          ? "Senha incorreta."
          : "Erro ao conectar. Tente novamente."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#f4f1ea] text-[#1e2a5a] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#1e2a5a] text-[#1e2a5a] font-display italic">
            L
          </span>
          <span className="font-display text-lg">{BRAND.name}</span>
        </div>

        <p className="overline">Acesso restrito</p>
        <h1 className="font-display mt-4 text-4xl sm:text-5xl tracking-tight leading-[1.05]">
          Painel administrativo
        </h1>
        <p className="mt-6 text-base text-[#5c5c5c] leading-relaxed">
          Digite a senha para ver os leads do site e os resultados do teste de
          nível.
        </p>

        <form onSubmit={onSubmit} className="mt-10 space-y-5">
          <label htmlFor="admin-password" className="flex flex-col gap-2">
            <span className="text-xs uppercase tracking-[0.18em] text-[#5c5c5c] font-medium">
              Senha
            </span>
            <Input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white border-[#e5e3db] focus-visible:ring-[#1e2a5a]/20 h-11"
            />
          </label>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-[#d9381e]">
              {error}
            </p>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={submitting}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#1e2a5a] px-6 py-3.5 text-sm font-medium text-[#f4f1ea] transition-colors hover:bg-[#d9381e] disabled:opacity-60"
          >
            {submitting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" /> Entrando…
              </>
            ) : (
              <>
                <Lock className="h-4 w-4" /> Entrar
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </>
            )}
          </button>

          <div className="pt-2 text-center">
            <Link
              to="/admin/forgot-password"
              data-testid="admin-forgot-link"
              className="text-sm link-underline text-[#5c5c5c]"
            >
              Esqueci a senha
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
